import React from 'react';

const ImageModal = ({
  src,
  alt,
  onClose,
}: {
  src: string;
  alt?: string;
  onClose: () => void;
}) => {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          maxWidth: '90%',
          maxHeight: '90%',
          borderRadius: '12px',
          boxShadow: '0 0 20px rgba(255,255,255,0.2)',
        }}
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

export default ImageModal;
